import { useTypedParams } from '@sorare/routing';

import { RewardsFixtureLeagueQualityRarityPage } from '@sorare/gameplay/src/pages/rewards/RewardsFixtureLeagueQualityRarityPage';

import { PageParams } from './__generated__/routeParams';

const NBARewardsFixtureLeagueQualityRarityPage = () => {
  const { league, quality, rarity } = useTypedParams<PageParams>();
  return (
    <RewardsFixtureLeagueQualityRarityPage
      league={league}
      quality={quality}
      rarity={rarity}
    />
  );
};

export default NBARewardsFixtureLeagueQualityRarityPage;
